import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["title", "subtitle"]
  static values = {
    isVersioning: {
      type: Boolean,
      default: false,
    },
    texts: Object
  }

  recording() {
    this.titleTarget.innerText = this.textsValue.title.recording
    this.subtitleTarget.innerHTML =
      this.textsValue.subtitle.recording.versioning[this.isVersioningValue]
  }

  pause() {
    this.titleTarget.innerText = this.textsValue.title.pause
    this.subtitleTarget.innerHTML = this.textsValue.subtitle.pause
  }

  stop() {
    this.titleTarget.innerText = this.textsValue.title.stop
    this.subtitleTarget.innerHTML = this.textsValue.subtitle.stop
  }

  handleRecording(event) {
    const status = event.detail.status
    if (status === "started") {
      this.recording()
    } else if (status === "paused") {
      this.pause();
    } else {
      this.stop();
    }
  }
}
